export default __webpack_public_path__ + "static/media/timeline.5ad9a92e.png";